module.exports = __webpack_public_path__ + "img/logo.9fd2b7d1.png";